import { FC } from "react";
import { useRevealContract } from "../../../../web3/reveal-hooks";
import "./revealPanel.scss";
import classNames from "classnames";
export const RevealPanel: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { userTokens, toggleSelectIds, selectedIds, reveal, revealAll } =
    useRevealContract();
  return (
    <div className="reveal-panel--wrap">
      <div className="reveal-panel--box">
        <div className="reveal-panel--list-top"></div>
        <div className="reveal-panel--close--box"></div>
        <div className="reveal-panel--close" onClick={onClose}></div>
        <div className="reveal-panel--list-view">
          <div className="reveal-panel--list-box">
            {userTokens.map((tokenId) => (
              <UserTokenView
                key={tokenId}
                tokenId={tokenId}
                selected={selectedIds.includes(tokenId)}
                onClick={() => {
                  toggleSelectIds(tokenId);
                }}
              />
            ))}
          </div>
        </div>
        <div className="reveal-panel--bottom">
          <BottomBtn
            onClick={()=>window.open("https://opensea.io/collection/sofa-maker")}
            text="OPENSEA"
            type="OS"
            disabled={selectedIds.length === 0 || userTokens.length === 0}
          />
          <BottomBtn
            onClick={reveal}
            text="REVEAL"
            type="reveal"
            disabled={selectedIds.length === 0 || userTokens.length === 0}
          />
          <BottomBtn
            onClick={revealAll}
            text="REVEAL ALL"
            type="reveal-all"
            disabled={userTokens.length === 0}
          />
        </div>
      </div>
    </div>
  );
};

const BottomBtn: FC<{
  onClick?: () => any;
  text: string;
  type: string;
  disabled: boolean;
}> = ({ onClick, text, type, disabled }) => {
  const clsName = classNames("reveal--bottom--btn", `btn-${type}`, {
    disabled,
  });
  return (
    <div
      className={clsName}
      onClick={() => {
        if (disabled) return;
        onClick && onClick();
      }}
    >
      {text}
    </div>
  );
};

export const UserTokenView: FC<{
  tokenId: number;
  selected: boolean;
  onClick: () => void;
}> = ({ tokenId, selected, onClick }) => {
  const imageUrl = `${process.env.REACT_APP_SERVER_PATH}/api/v1/image/maker?tokenId=${tokenId}`;
  return (
    <div
      className={classNames("reveal-nft-item", { selected })}
      style={{backgroundImage:`url("${imageUrl}")`}}
      onClick={onClick}
    >
      <div className="reveal-nft-item--name">SOFA #{tokenId}</div>
    </div>
  );
};
